import { REVOKE_CONFIGURATION, REVOKE_CONFIGURATION_SUCCESS, REVOKE_CONFIGURATION_ERROR, REVOKE_CONFIGURATION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RevokeConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case REVOKE_CONFIGURATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case REVOKE_CONFIGURATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case REVOKE_CONFIGURATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case REVOKE_CONFIGURATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RevokeConfiguration;
